import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { VisitorTrackingDashboard } from '@/components/analytics/VisitorTrackingDashboard';

export default function VisitorAnalytics() {
  return (
    <DashboardLayout>
      <VisitorTrackingDashboard />
    </DashboardLayout>
  );
}
